// @flow
import { createMuiTheme } from '@material-ui/core/styles'

const muiTheme = (colors, primaryColor, overrides, palette = {}) => createMuiTheme({
    palette: {
        primary: {
            light: colors.primaryOneLighten5,
            main: primaryColor || colors.primaryOne,
            dark: colors.primaryOneDarken5,
        },
        secondary: {
            light: colors.blueLighten5,
            main: colors.blue,
            dark: colors.blueDarken5,
        },
        action: {
            light: colors.primaryOneLighten5,
            main: primaryColor || colors.secondaryTwo,
            dark: colors.primaryOneDarken5,
        },
        error: {
            light: colors.dangerLighten5,
            main: colors.danger,
            dark: colors.dangerDarken5,
        },
        ...palette,
    },
    typography: {
        fontFamily: '\'Roboto Condensed\', sans-serif',
        useNextVariants: true,
    },
    overrides: overrides || {
    },
})

export default muiTheme
